import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';

import {toggleValueInList} from 'iss/utils/functional';
import {Validator} from 'iss/widgets/form/validation/Validator';

export class Field extends React.Component {
  static contextTypes = {
    formApi: PropTypes.object.isRequired,
  };
  static defaultProps = {
    valuePath: [],
    pure: false,
  };
  fieldApi = {
    getValue: () => this.context.formApi.getValue(this.props.valuePath),
    setValue: (value) => {
      this.context.formApi.setValue(this.props.valuePath, value);
      if (this.props.onChange) this.props.onChange(value);
    },
    updateValue: (updater) => {
      const updated = updater(this.fieldApi.getValue());
      this.fieldApi.setValue(updated);
    },
  };
  shouldComponentUpdate(nextProps) {
    if (!this.props.pure) return true;
    if (!R.equals(R.dissoc("children", nextProps), R.dissoc("children", this.props))) return true;
    if (this.props.valuePath === undefined) return true;
    return this.context.formApi.hasChanged(this.props.valuePath);
  }
  render() {
    return this.props.children(this.fieldApi);
  }
}

function FormComponent({valuePath, pure, validate, children, ...props}) {
  return <Field pure={pure} valuePath={valuePath} {...props}>
    {(fieldApi) => {
      const field = {value: fieldApi.getValue(), onChange:fieldApi.setValue};
      if (!validate) {
        return children({...field, error: ""}, fieldApi);
      }

      return <Validator value={fieldApi.getValue()} validate={validate}>
        {validationApi => {
          const error = validationApi.getShownErrors().join("\n");
          return children({...field, error}, fieldApi);
        }}
      </Validator>;
    }}
  </Field>;
}

export function formComponent(WrappedComponent, {pure} = {pure: true}) {
  return (props) => {
    return <FormComponent pure={pure} {...props}>
      {inputProps => <WrappedComponent {...props} {...inputProps}/>}
    </FormComponent>;
  };
}

export function selectorFormComponent(WrappedComponent, {pure} = {pure: true}) {
  return (props) => {
    return <FormComponent pure={pure} {...props}>
      {(inputProps, fieldApi) => {
        const identity = props.selectionIdentity || (a => a);
        const api = props.multi ?
          getMultiSelectorApi(fieldApi, identity) :
          getSelectorApi(fieldApi, identity);
        return <WrappedComponent {...props} {...inputProps} {...api}/>;
      }}
    </FormComponent>;
  };
}

function getSelectorApi(fieldApi, identity) {
  const selected = R.defaultTo(null, fieldApi.getValue());
  return {
    value: selected,
    isChosen: value => selected && identity(selected) === identity(value),
    onChange: fieldApi.setValue,
    onToggle: fieldApi.setValue,
  };
}

function getMultiSelectorApi(fieldApi, identity) {
  const selected = fieldApi.getValue() || [];
  const api = {
    value: selected,
    isChosen: value => {
      const id = identity(value);
      return selected.length && R.any(item => id === identity(item), selected);
    },
    onChange: fieldApi.setValue,
    onToggle: toggled => fieldApi.updateValue(
      toggleValueInList(toggled, val => val2 => identity(val) === identity(val2))),
  };
  return api;
}

export default Field;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/Field.jsx